/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, ErrorInfo, ReactNode } from 'react'

import ErrorStatement from './ErrorStatement'

interface ErrorBoundaryProps {
  children?: ReactNode
  blockName?: string
}

interface ErrorBoundaryState {
  hasError: boolean
  errorInfo: ErrorInfo | null
  error: Error | null
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, errorInfo: null, error: null }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ hasError: true, error, errorInfo })
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <ErrorStatement title={this.state.error.name}>
          <p>
            {this.state.error?.message} at: {this.props.blockName}
          </p>
          <p>{this.state.errorInfo?.componentStack}</p>
        </ErrorStatement>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
